import { ButtonBase, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link as RouterLink } from "react-router-dom";
import { onboardingTokens } from "../../theme";

/**
 * A card that takes the member straight to the part of Echo a goal points at.
 * Replaces Done in history: onboarding is finished, so back has nothing to show.
 */
const NextStepCard = ({ to, title, cta }) => (
  <ButtonBase
    component={RouterLink}
    to={to}
    replace
    sx={{
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      p: 2,
      mb: 3,
      textAlign: "left",
      borderRadius: "14px",
      color: onboardingTokens.navy,
      backgroundColor: onboardingTokens.card,
      border: `1.5px solid ${onboardingTokens.border}`,
      "@media (hover: hover)": {
        "&:hover": { borderColor: onboardingTokens.teal },
      },
    }}
  >
    <Typography sx={{ fontSize: "0.9375rem", fontWeight: 500 }}>
      {title}
    </Typography>
    <Stack direction="row" alignItems="center" gap={0.5} sx={{ flexShrink: 0 }}>
      <Typography sx={{ fontSize: "0.8125rem", fontWeight: 600 }}>
        {cta}
      </Typography>
      <ArrowForwardIcon sx={{ fontSize: 16, color: onboardingTokens.teal }} />
    </Stack>
  </ButtonBase>
);

export default NextStepCard;
